import { render, staticRenderFns } from "./blockSpacList.vue?vue&type=template&id=08603e69&scoped=true"
import script from "./blockSpacList.vue?vue&type=script&lang=js"
export * from "./blockSpacList.vue?vue&type=script&lang=js"
import style0 from "./blockSpacList.vue?vue&type=style&index=0&id=08603e69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08603e69",
  null
  
)

export default component.exports